import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, ViewChild, TemplateRef, Inject, OnChanges, SimpleChanges } from '@angular/core';
import { TableAction } from '@huge-monorepo/hip/domain';
import { TableHeader } from '@huge-monorepo/hip/domain';
import { GenericService } from '@huge-monorepo/hip/services';
import { TableSearch } from '@huge-monorepo/hip/domain';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { MatTableDataSource as MatTableDataSource, MatTable as MatTable } from '@angular/material/table';
import { Sort } from '@angular/material/sort';
import { SelectionModel } from '@angular/cdk/collections';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ToolsService } from '@huge-monorepo/hip/services';
import { TableConfig } from '@huge-monorepo/hip/domain';
import { Environment } from '@huge-monorepo/hip/services';
import { CurrencyPipe } from '@angular/common';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { isBuffer } from 'util';
import { MatCheckboxChange } from '@angular/material/checkbox';

export class TableRefresh {
  constructor(public Enabled: Boolean, public Unobtrusive: Boolean, public Interval: number, public UpdateInterval: any) { }
}

export class TableExpansion {
  constructor(public Template: Function, public Expandable: Boolean = false, public tools?: ToolsService, public HtmlTemplate?: TemplateRef<any>, public currencyConverterPipe?: CurrencyPipe) { }
}

export class AdvancedSearch {
  constructor(public Enabled: Boolean, public Callback: Function, public Text: string = 'Advanced', public Open: Boolean = false) { }
}

export class CheckOption {
  constructor(public Text: String, public Name: string, public Value: any) { }
}

export class Style {
  constructor(public FontSize: number) { }
}

export class SideTagConfig {
  constructor(
    public PropertyID: string,
    public ColourMapping: { [key: string]: string },
    public tooltipTextFn?: (element: any) => string
  ) { }
}

@Component({
  selector: 'tools-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class TableComponent implements OnInit, OnDestroy, OnChanges {
  @ViewChild(MatTable, { static: false }) matTable: MatTable<any>;
  // @ViewChild('typeInput', {static: false}) public typeInput: SearchableComboboxComponent;

  @Input() TableConfig: TableConfig;
  @Input() Headers: TableHeader[];
  @Input() Selectable: boolean = false;
  @Input() SelectionHighlight: boolean = false;
  @Input() ButtonRows: boolean = false;
  @Input() Multiple: boolean = false;
  @Input() SelectAll: boolean = false;
  @Input() SetAllSelected: boolean = false;
  @Input() Actions: TableAction[];
  @Input() SearchData: TableSearch = {
    Error: 'You should select at least one value.',
    Placeholder: 'search...',
    Required: true,
    Class: 'default-input',
  };
  @Input() SavedSearch: string = null;
  @Input() Search: boolean = true;
  @Input() ApiPath: string = '';
  @Input() Data: any[] = null;
  @Input() DataCount: number = null;
  @Input() SelectionData: any[] = null;
  @Input() DisplayCount: number = 10;
  @Input() SortColumn: string = '';
  @Input() PrimaryColumn: string = 'ID';
  @Input() Desc: boolean = false;
  @Input() ExtraQuery: string = null;
  @Input() CountApiPath: string = null;
  @Input() CSS: string = null;
  @Input() DefaultWidth: number = 150;
  @Input() Add: boolean = false;
  @Input() Client: boolean = false;
  @Input() ParseDate: Boolean = true;
  @Input() HTTPPost: Boolean = false;
  @Input() HTTPData: Object = null;
  @Input() Variadic: Boolean = false;
  @Input() TableActions: any[] = null;
  @Input() Heading: string;
  @Input() DynamicCount: Boolean = false;
  @Input() Slim: Boolean = false;
  @Input() ExpansionConfig: TableExpansion = new TableExpansion(null, false);
  @Input() RefreshConfig: TableRefresh = new TableRefresh(false, false, 1, null);
  @Input() AdvancedSearchConfig: AdvancedSearch = new AdvancedSearch(false, null);
  @Input() CheckOptions: CheckOption[];
  @Input() AdditionalCheckOptions: CheckOption[];
  @Input() SelectedCheckOption: CheckOption;
  @Input() SelectedAdditionalCheckOption: CheckOption;
  @Input() DataLoadFunc: Function = null;
  @Input() Style: Style = new Style(10);
  @Input() OptionsAlignment: string = 'center';
  @Input() HasCustomPaginator: Boolean = false; // Used to determine if there is custom function that will paginate through parent data.
  @Input() HasCustomSort: Boolean = false; // Used to determine if there is custom function that will sort through parent data.
  @Input() PageIndex: number;
  @Input() addButtonText: string = '';
  @Input() disableRowClick: boolean = false;
  @Input() radioButtonStyle: string = 'text-right';
  @Input() radioButtonFloat: string = 'right';
  @Input() sideTagConfig?: SideTagConfig = null;
  @Input() JobNumberExactMatch: Boolean = false;
  @Input() ClearSelectAllOnSearch: Boolean = false;
  @Input() DisplayAllData: boolean = false;
  @Input() DetectDataChanges: boolean = false;
  @Input() CustomSearchFn: (search: string, data: any[]) => any[] = null;
  @Input() CustomClearFn: () => any[] = null;
  @Input() SelectDisabledFn: (row: any) => boolean = null;
  @Input() LocalizeSelectAll: boolean = false;
  @Input() ClearSelectionOnClear: boolean = true;
  @Input() ScrollLimit?: number = null;
  @Input() RowGap?: number | null = null;
  @Input() SelectPage: boolean = false;
  @Input() PageSizeOptions: any[] | null = null;
  @Input() IncludeAllPageSize: boolean = false;
  @Input() SavePage: boolean = false;
  @Input() SavedOffset: number | null = null;
  @Input() SavedPageIndex: number | null = null;
  @Input() checkOptionType: 'radio' | 'select' | 'combobox' = 'radio';
  @Input() optionsTitle: string = 'Select Option';
  @Input() additionalOptionsTitle: string = 'Select Additional Option';
  @Input() detectUrlChanges: boolean = false;

  @Output() Selected: EventEmitter<any> = new EventEmitter<any>();
  @Output() AllSelected: EventEmitter<any> = new EventEmitter<boolean>();
  @Output() PageSelected: EventEmitter<any> = new EventEmitter<boolean>();
  @Output() AddChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() AddChangeClient: EventEmitter<any> = new EventEmitter<any>();
  @Output() SearchChange: EventEmitter<string> = new EventEmitter<string>();
  @Output() CheckOptionChanged: EventEmitter<any> = new EventEmitter<any>();
  @Output() AdditionalCheckOptionChanged: EventEmitter<any> = new EventEmitter<any>();
  @Output() CustomPagination: EventEmitter<any> = new EventEmitter<any>();
  @Output() CustomSort: EventEmitter<any> = new EventEmitter<any>();
  @Output() AllSelectedList: EventEmitter<any> = new EventEmitter<any>();
  @Output() PageSelectedList: EventEmitter<any> = new EventEmitter<any>();
  @Output() ResultsRetrieved: EventEmitter<any> = new EventEmitter();
  @Output() isExactMatchChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() extraQueryClear: EventEmitter<void> = new EventEmitter<void>();
  @Output() selectedDateChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() Deselected: EventEmitter<any> = new EventEmitter<any>();
  @Output() ScrollLimitReached: EventEmitter<any> = new EventEmitter<any>();
  @Output() ElementExpanded: EventEmitter<any> = new EventEmitter<any>();
  @Output() OffsetChanged: EventEmitter<any> = new EventEmitter<any>();
  columnHeaders: string[] = [];
  loading: boolean = true;
  searchTerm = new UntypedFormControl(this.SavedSearch);
  dataSource = new MatTableDataSource<any>();
  selection: SelectionModel<any>;
  sortObject = {};
  allToggledModel: boolean = false;
  allPageToggledModel: boolean = false;
  expandedElement: Object | null;
  Offset: number = 0;
  checkOptionValue: any = null;
  additionalCheckOptionValue: any = null;
  currentSelectionData: any[] = null;
  customData: Boolean = false; // Is set when parent sends data to table.
  isExactMatch: boolean = false;
  @Input() selectedDate: string;
  dateChosen: Date;
  displayDate: Date;
  localAllSelected: boolean = false;

  DynaCountValidator = new UntypedFormControl('', [Validators.required, Validators.minLength(1)]);

  constructor(private db: GenericService, public dialog: MatDialog, public tools: ToolsService, @Inject(Environment) private environment: any) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.DetectDataChanges) {
      if (changes['Data']) {
        this.Data = changes['Data'].currentValue;
        this.unobtrusiveDataUpdate();
      }
    }
    if (this.detectUrlChanges) {
      if (changes['ApiPath'] || changes['ExtraQuery']) {
        this.refresh();
      }
    }
  }

  ngOnDestroy() {
    this.destroyStyles();

    if (this.TableConfig != null && this.TableConfig.RefreshConfig != null && this.TableConfig.RefreshConfig.UpdateInterval != null) {
      this.tools.DestroyInterval(this.RefreshConfig.UpdateInterval);
    } else if (this.RefreshConfig != null && this.RefreshConfig.UpdateInterval != null) {
      // TODO: To be deprecated in favor of TableConfig
      this.tools.DestroyInterval(this.RefreshConfig.UpdateInterval);
    }
  }

  destroyStyles() {
    const style = document.getElementById('generic-table-styles');
    const head = document.getElementsByTagName('head')[0];
    if (head != null && style != null) {
      head.removeChild(style);
    }
  }

  ngOnInit() {
    if (this.TableConfig != null && this.TableConfig.SavedSearch != null) {
    } else if (this.SavedSearch) {
      // TODO: To be deprecated in favor of TableConfig
      this.searchTerm.setValue(this.SavedSearch);
    }

    this.checkOptionValue = this.SelectedCheckOption;
    this.additionalCheckOptionValue = this.SelectedAdditionalCheckOption;

    if (this.SavePage && this.SavedOffset != null) {
      this.Offset = this.SavedOffset;
      this.PageIndex = this.SavedPageIndex != null ? this.SavedPageIndex : 0;
    }

    this.buildHeaders();
    this.applyStyles();
    if (this.TableConfig != null) {
      // TODO: Remove 'IF' check and entire 'ELSE' when TableConfig is the only @Input()
      this.currentSelectionData = this.TableConfig.SelectionData;
    } else {
      this.currentSelectionData = this.SelectionData;
    }
    if (this.currentSelectionData != null) {
      for (let i = 0; i < this.currentSelectionData.length; i++) {
        this.selection.select(this.currentSelectionData[i]);
      }
    }

    if (this.TableConfig != null && this.TableConfig.Data != null) {
      if (this.TableConfig.DataCount == null) {
        this.DataCount = this.Data.length;
        if (this.IncludeAllPageSize && this.PageSizeOptions != null && this.PageSizeOptions.length > 0) {
          const pageSizeMax = Math.max(...this.PageSizeOptions);
          if (this.DataCount > pageSizeMax) {
            this.PageSizeOptions.push(this.DataCount);
          }
        }
      }
      this.customData = true;

      this.dataSource = new MatTableDataSource<any>(this.Data);
      if (this.HasCustomPaginator) {
        this.handleRequestResponse(this.Data, this.Offset);
      } else {
        this.handleRequestResponse(this.Data, 0);
      }
      this.loading = false;
    } else if (this.Data != null) {
      // TODO: To be deprecated in favor of TableConfig
      if (this.DataCount == null) {
        this.DataCount = this.Data.length;
        if (this.IncludeAllPageSize && this.PageSizeOptions != null && this.PageSizeOptions.length > 0) {
          const pageSizeMax = Math.max(...this.PageSizeOptions);
          if (this.DataCount > pageSizeMax) {
            this.PageSizeOptions.push(this.DataCount);
          }
        }
      }
      this.customData = true;
      this.dataSource = new MatTableDataSource<any>(this.Data);
      if (this.HasCustomPaginator) {
        this.handleRequestResponse(this.Data, this.Offset);
      } else {
        this.handleRequestResponse(this.Data, 0);
      }
      this.loading = false;
    } else {
      this.loading = true;
      this.GetData(this.Offset, this.searchTerm.value);
      if (this.TableConfig != null && this.TableConfig.RefreshConfig != null && this.TableConfig.RefreshConfig.Enabled == true) {
        this.createRefreshInterval();
      } else if (this.RefreshConfig != null && this.RefreshConfig.Enabled == true) {
        // TODO: To be deprecated in favor of TableConfig
        this.createRefreshInterval();
      }
    }

    if (this.TableConfig != null && this.TableConfig.SetAllSelected) {
      this.allToggled();
    } else if (this.SetAllSelected) {
      // TODO: To be deprecated in favor of TableConfig
      this.allToggled();
    }

    if (this.selectedDate) {
      this.displayDate = new Date(this.selectedDate);
    }
  }

  createRefreshInterval(refreshImmediately: boolean = false) {
    if (this.TableConfig != null && this.TableConfig.RefreshConfig.UpdateInterval != null) {
      this.tools.DestroyInterval(this.RefreshConfig.UpdateInterval);
    } else if (this.RefreshConfig.UpdateInterval != null) {
      // TODO: To be deprecated in favor of TableConfig
      this.tools.DestroyInterval(this.RefreshConfig.UpdateInterval);
    }

    if (refreshImmediately) {
      this.GetData(this.Offset, this.searchTerm.value);
    }

    if (this.TableConfig != null && this.TableConfig.RefreshConfig != null && this.TableConfig.RefreshConfig.Enabled) {
      // TODO: To be deprecated in favor of TableConfig
      setTimeout(() => {
        this.TableConfig.RefreshConfig.UpdateInterval = setInterval(() => {
          this.GetData(this.Offset, this.searchTerm.value);
        }, this.TableConfig.RefreshConfig.Interval * 1000 * 60);
      }, 200);
    } else if (this.RefreshConfig != null && this.RefreshConfig.Enabled) {
      // TODO: To be deprecated in favor of TableConfig
      setTimeout(() => {
        this.RefreshConfig.UpdateInterval = setInterval(() => {
          this.GetData(this.Offset, this.searchTerm.value);
        }, this.RefreshConfig.Interval * 1000 * 60);
      }, 200);
    }
  }

  add() {
    if (this.AddChange && this.Client == false) {
      this.AddChange.emit(true);
    }
    if (this.AddChange && this.Client == true) {
      this.AddChangeClient.emit(true);
    }
  }

  buildHeaders() {
    this.columnHeaders = [];

    if (this.sideTagConfig != null) {
      this.columnHeaders = ['status'];
    }

    if (this.TableConfig != null && this.TableConfig.Selectable) {
      if (!this.TableConfig.SelectionHighlight) {
        if (this.columnHeaders == null)
          this.columnHeaders = ['check'];
        else
          this.columnHeaders.push('check');
      }
      this.selection = this.TableConfig.Multiple ? new SelectionModel<any>(true, []) : new SelectionModel<any>(false, []);
    } else if (this.Selectable) {
      // TODO: To be deprecated in favor of TableConfig
      if (!this.SelectionHighlight) {
        if (this.columnHeaders == null)
          this.columnHeaders = ['check'];
        else
          this.columnHeaders.push('check');
      }
      this.selection = this.Multiple ? new SelectionModel<any>(true, []) : new SelectionModel<any>(false, []);
    }

    if (this.TableConfig != null && this.TableConfig.Headers != null) {
      this.TableConfig.Headers.forEach((element) => {
        if (element.Text.length == 0) {
          element.Text = this.createRandomID(3);
        }
        if (element.ID == null || element.ID == '') {
          element.ID = element.Text.replace(/\s/g, '');
        }
        if (!element.Hidden) {
          this.columnHeaders.push(element.ID);
        }
      });
    } else if (this.Headers != null) {
      // TODO: To be deprecated in favor of TableConfig
      this.Headers.forEach((element) => {
        if (element.Text.length == 0) {
          element.Text = this.createRandomID(3);
        }
        if (element.ID == null || element.ID == '') {
          element.ID = element.Text.replace(/\s/g, '');
        }
        if (!element.Hidden) {
          this.columnHeaders.push(element.ID);
        }
      });
    }

    if (this.TableConfig != null && this.TableConfig.Actions != null && this.TableConfig.Actions.length > 0) {
      this.columnHeaders.push('actions');
    } else if (this.Actions != null && this.Actions.length > 0) {
      // TODO: To be deprecated in favor of TableConfig
      this.columnHeaders.push('actions');
    }

  }

  applyStyles() {
    if (this.CSS == null) {
      this.CSS = '';
    }
    this.Headers.forEach((element) => {
      this.CSS +=
        '.mat-column-' +
        element.ID +
        ' { word-wrap: break-word !important; white-space: unset !important; flex: 0 0 200px !important; width: ' +
        (element.Width != null ? element.Width : this.DefaultWidth) +
        'px !important; overflow-wrap: break-word; word-wrap: break-word; text-align: ' +
        (element.Align != null ? element.Align : 'center') +
        ' !important; word-break: break-word; -ms-hyphens: auto; -moz-hyphens: auto; -webkit-hyphens: auto; hyphens: auto; height: ' +
        (this.Slim ? 'auto;' : '20px;') +
        ' font-size: ' +
        (this.Style.FontSize + 1) +
        'pt;}';
      // this.CSS += 'td.mat-column-' + element.ID + ':first-of-type > div { padding-left: ' + (element.Align != null && element.Align == 'left' ? '20px !important' : '0') + '; }';
    });
    if (this.Slim && !this.ExpansionConfig.Expandable) {
      this.CSS += '.mat-row { height: auto !important; } .mat-cell { padding: 8px 8px 8px 0 !important; font-size: ' + this.Style.FontSize + 'pt; }';
    }
    const head = document.getElementsByTagName('head')[0];
    const style = document.createElement('style');
    style.type = 'text/css';
    style.id = 'generic-table-styles';
    style.appendChild(document.createTextNode(this.CSS));
    head.appendChild(style);
  }

  refresh() {
    if (this.SavedSearch == null || this.SavedSearch == '') {
      this.searchTerm.setValue(null);
    }
    this.currentSelectionData = this.SelectionData;
    if (this.selection) {
      this.selection.clear();
    }
    this.createRefreshInterval(true);
  }

  ClearSelection() {
    this.currentSelectionData = [];
    this.refresh();
  }

  sortData(sort: Sort) {
    this.sortObject = sort;
    if (this.HasCustomSort) {
      this.CustomSort.emit(sort);
      return;
    }

    if (!sort) {
      this.GetData(this.Offset, this.searchTerm.value);
    } else {
      this.Desc = sort.direction !== 'asc';
      this.SortColumn = sort.direction == '' ? '' : sort.active;
      this.GetData(this.Offset, this.searchTerm.value);
    }
  }

  GetDataCount(search: string = '') {
    let queryParams = (this.ExtraQuery != null ? this.ExtraQuery + '&' : '?') + 'search=' + (search != null && search != 'null' ? search : '');
    let url = this.environment.apiLink + this.CountApiPath + queryParams;
    if (this.HTTPPost === true) {
      this.HTTPData['Search'] = this.searchTerm.value;
      const request = this.db.POST(url, this.HTTPData);
      request.subscribe((tmpCount) => {
        this.DataCount = Math.ceil(tmpCount as number);
        if (this.IncludeAllPageSize && this.PageSizeOptions != null && this.PageSizeOptions.length > 0) {
          const pageSizeMax = Math.max(...this.PageSizeOptions);
          if (this.DataCount > pageSizeMax) {
            this.PageSizeOptions.push(this.DataCount);
          }
        }
      });
    } else {
      const request = this.db.GET(url);
      request.subscribe((tmpCount) => {
        this.DataCount = Math.ceil(tmpCount['body'] as number);
        if (this.IncludeAllPageSize && this.PageSizeOptions != null && this.PageSizeOptions.length > 0) {
          const pageSizeMax = Math.max(...this.PageSizeOptions);
          if (this.DataCount > pageSizeMax) {
            this.PageSizeOptions.push(this.DataCount);
          }
        }
      });
    }
  }
  onExactMatchChange(newValue: boolean): void {
    this.isExactMatch = newValue;
    this.isExactMatchChange.emit(newValue);
  }

  onMonthChange(ev: any) {
    // Handle any additional logic when the month changes
    this.dateChosen = new Date(ev);
    const myDate = new Date(this.dateChosen.getTime() - this.dateChosen.getTimezoneOffset() * 60000);
    this.selectedDate = myDate.toISOString().split('T')[0];
    this.selectedDateChange.emit(this.selectedDate);
  }

  searchText() {
    if (this.ClearSelectAllOnSearch && this.allToggledModel) {
      this.allToggledModel = false;
      this.selection.clear();
      this.AllSelected.emit(this.allToggledModel);
    }
    this.SearchChange.emit(this.searchTerm.value);
    if (this.CustomSearchFn != null) {
      this.loading = true;
      setTimeout(() => {
        this.Data = this.CustomSearchFn(this.searchTerm.value, this.Data);
        this.unobtrusiveDataUpdate();
        this.loading = false;
      });
    } else if (this.customData && this.HasCustomPaginator) {
      this.CustomPagination.emit({ offset: 0, search: this.searchTerm.value });
    } else {
      this.GetData(0, this.searchTerm.value);
    }

    if (this.LocalizeSelectAll) {
      let allSelectedLocal = true;
      for (let i = 0; i < this.Data.length; i++) {
        if (!this.selection.isSelected(this.Data[i])) {
          allSelectedLocal = false;
          break;
        }
      };
      this.localAllSelected = allSelectedLocal;
    }
  }

  GetData(offset: number = 0, search: string = '') {
    if (this.ApiPath != null && this.ApiPath.length > 0) {
      this.loading = this.RefreshConfig.Unobtrusive ? this.loading : true;
      console.log(this.ExtraQuery);
      let queryParams =
        (this.ExtraQuery != null ? this.ExtraQuery + '&' : '?') +
        (this.DisplayAllData ? '' : 'count=' +
          (this.DisplayCount != null ? this.DisplayCount : 10))
        +
        '&offset=' +
        offset +
        '&search=' +
        (search != null && search != 'null' ? search : '') +
        '&orderBy=' +
        this.SortColumn +
        '&desc=' +
        (this.Desc != null ? this.Desc : false);

      let url = this.environment.apiLink + this.ApiPath + queryParams;
      this.ResultsRetrieved.emit({
        OrderBy: this.SortColumn,
        Desc: this.Desc,
      });
      if (this.CountApiPath != null) {
        this.GetDataCount(search);
      }
      if (this.HTTPPost === true) {
        const request =  this.db.POSTANDOBSERVE(url, this.HTTPData);
        request.subscribe(
          (results) => {

            if (this.Variadic == true) {
              let providedHeaders = JSON.parse(results['headers'].get('x-columns'));
              this.Headers.forEach((element) => {
                element.Hidden = true;
                providedHeaders.forEach((prov) => {
                  if (element.VariadicIdentifier == prov) {
                    element.Hidden = false;
                  }
                });
              });
              this.destroyStyles();
              this.columnHeaders = [];
              this.buildHeaders();
              this.applyStyles();
            }
            this.handleRequestResponse(results['body'], offset);
            if (this.CountApiPath == null && results['body'] != null) {
              let countObj = this.tools.getPaginationHeaders(results);
              if (countObj) {
                this.DataCount = Math.ceil(countObj['TotalCount'] as number);
                if (this.IncludeAllPageSize && this.PageSizeOptions != null && this.PageSizeOptions.length > 0) {
                  const pageSizeMax = Math.max(...this.PageSizeOptions);
                  if (this.DataCount > pageSizeMax) {
                    this.PageSizeOptions.push(this.DataCount);
                  }
                }
              }
            }
          },
          (err) => {
            this.loading = false;
          },
        );
      } else {
        console.log(url);

        const request = this.db.GET(url);
        request.subscribe(
          (results: any) => {
            this.handleRequestResponse(results['body'], offset);
            if (this.CountApiPath == null && results['body'] != null) {
              let pagination = JSON.parse(results['headers'].get('x-pagination'));
              this.DataCount = Math.ceil(pagination != null ? (pagination['TotalCount'] as number) : 0);
              if (this.IncludeAllPageSize && this.PageSizeOptions != null && this.PageSizeOptions.length > 0) {
                const pageSizeMax = Math.max(...this.PageSizeOptions);
                if (this.DataCount > pageSizeMax) {
                  this.PageSizeOptions.push(this.DataCount);
                }
              }
            }
          },
          (err) => {
            this.loading = false;
          },
        );
      }
    } else {
      this.loading = false;
    }
  }

  handleActions(elem: any): boolean {
    let ret = 0;
    if (this.Actions != null) {
      this.Actions.forEach((act) => {
        if (act['Validator'] == null || (act['Validator'] != null && act['Validator'](elem) == true)) {
          ret++;
        }
      });
    }
    return ret > 0;
  }

  handleRequestResponse(results, offset) {
    if (results != null && results.length != null) {
      this.Data = results as [];
      if (this.Data == null) {
        this.Data = [];
      }

      if (this.DataLoadFunc != null) {
        this.DataLoadFunc(this.Data);
      }

      if (offset == 0) {
        if (this.RefreshConfig.Unobtrusive === true && this.dataSource.data.length > 0) {
          this.unobtrusiveDataUpdate();
        } else {
          this.Data.forEach((elem) => {
            elem['showActions'] = this.handleActions(elem);
          });
          if (this.HasCustomPaginator && !this.DisplayAllData) {
            this.dataSource = new MatTableDataSource<any>(this.Data.slice(0, this.DisplayCount));
          } else {
            this.dataSource = new MatTableDataSource<any>(this.Data);
          }
        }
      } else {
        if (this.RefreshConfig.Unobtrusive === true && this.dataSource.data.length > 0) {
          this.unobtrusiveDataUpdate();
        } else {
          this.Data.forEach((elem) => {
            elem['showActions'] = this.handleActions(elem);
          });

          if (this.HasCustomPaginator && !this.DisplayAllData) {
            this.dataSource.data = this.Data.slice(offset, offset + this.DisplayCount);
          } else {
            this.dataSource.data = this.Data;
          }
        }
      }

      if (this.Selectable) {
        if (this.AllSelected && this.allToggledModel) {
          this.dataSource.data.forEach((row) => this.selection.select(row));
        } else {
          this.checkIfChecked();
        }
      }
    } else {
      this.Data = [];
      this.DataCount = 0;
    }

    this.loading = false;
  }

  unobtrusiveDataUpdate() {

    if (this.expandedElement != null) {
      let found = false;
      this.Data.forEach((element) => {
        if (element['id'] == this.expandedElement['id']) {
          found = true;
          this.expandedElement = element;
        }
        element['showActions'] = this.handleActions(element);
      });
      if (!found) {
        this.expandedElement = null;
      }
    } else {
      this.Data.forEach((element) => {
        element['showActions'] = this.handleActions(element);
      });
      this.checkIfChecked();
      this.dataSource = new MatTableDataSource<any>(this.Data);
      this.ReRenderRows();
      return;
    }

    if (this.LocalizeSelectAll) {
      let allSelected = true;
      for (let i = 0; i < this.Data.length; i++) {
        if (!this.selection.isSelected(this.Data[i])) {
          allSelected = false;
          break;
        }
      };
      this.localAllSelected = allSelected;
    }

    this.dataSource.connect().next(this.Data);
  }

  getServerData(event: any) {
    if (this.PageSizeOptions != null && this.PageSizeOptions.length > 0 && event.pageSize != null) {
      this.DisplayCount = event.pageSize;
    }

    this.Offset = event.pageIndex * (this.DisplayAllData ? 0 : this.DisplayCount);
    if (this.SavePage) {
      this.OffsetChanged.emit({ offset: this.Offset, pageIndex: event.pageIndex });
    }
    if (this.customData && this.HasCustomPaginator) {
      this.handleRequestResponse(this.Data, this.Offset);
      // this.CustomPagination.emit({offset: this.Offset, search: this.searchTerm.value, page: event.pageIndex});
    } else {
      this.GetData(this.Offset, this.searchTerm.value);
    }
    return event;
  }

  createRandomID(length: number): string {
    let result = '';
    let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  unMarkAsTouched() {
    this.searchTerm.setErrors(null);
  }

  markAsTouched() {
    this.searchTerm.setErrors({
      invalid: true,
    });
    this.searchTerm.markAsTouched();
  }

  rowClicked(row) {

    if (this.disableRowClick) return;
    if (this.ButtonRows === true) {
      this.buttonRowClicked(row);
      return;
    }
    if (this.ExpansionConfig.Expandable === false) {
      this.checkBoxChecked(row);
    }
    this.checkRowExpansion(row);
  }

  buttonRowClicked(row) {
    if (row != null) {
      this.unMarkAsTouched();
      this.currentSelectionData = [row];
      this.broadcastSingle(row);
    }

  }

  broadcastSingle(data) {
    this.Selected.emit(data);
  }

  checkBoxChecked(row) {
    if (row != null && this.selection != null) {
      if (this.SelectDisabledFn == null || !this.SelectDisabledFn(row)) {
        this.unMarkAsTouched();
        if (!this.Multiple) {
          this.selection.selected.forEach((element) => {
            element.Checked = false;
          });
          this.currentSelectionData = [];
          if (this.selection.selected[0] != row) {
            this.selection.clear();
          }
        }
        this.selection.toggle(row);
        row.Checked = !!!row.Checked;

        if (this.selection.isSelected(row)) {
          this.AddToSelection(row);
        } else {
          this.RemoveFromSelection(row);
        }
        this.broadcastSelected();
      }
    }
  }

  // isChecked(elem) : boolean {
  //   if (this.currentSelectionData == null) {
  //     return false;
  //   }

  //   this.currentSelectionData.forEach(element => {
  //     if (element[this.PrimaryColumn] == elem[this.PrimaryColumn]) {
  //       return true;
  //     }
  //   });
  //   return false;
  // }

  AddToSelection(elem) {
    let found = false;
    if (this.currentSelectionData == null) {
      this.currentSelectionData = [];
    }

    this.currentSelectionData.forEach((element) => {
      if (!found && element[this.PrimaryColumn] == elem[this.PrimaryColumn]) {
        found = true;
      }
    });

    if (!found) {
      this.currentSelectionData.push(elem);
    }
  }

  RemoveFromSelection(elem) {
    if (this.currentSelectionData != null) {
      for (let i = 0; i < this.currentSelectionData.length; i++) {
        if (this.currentSelectionData[i][this.PrimaryColumn] == elem[this.PrimaryColumn]) {
          this.currentSelectionData.splice(i, 1);
          break;
        }
      }
    }
  }

  broadcastSelected() {
    // this.Selected.emit(this.currentSelectionData); Why would you only want 1 value?
    this.Selected.emit(this.selection.selected);
  }

  checkIfChecked() {
    if (this.selection != null && this.selection.selected != null) {
      this.selection.selected.forEach((select) => {
        this.dataSource.data.forEach((dataRow) => {
          if (dataRow[this.PrimaryColumn] == select[this.PrimaryColumn]) {
            // if (this.selection.selected.indexOf( (elem) => {
            //   return elem[this.PrimaryColumn] == dataRow[this.PrimaryColumn];
            // }) == -1) {
            //   this.selection.select(dataRow);
            // }
            dataRow.Checked = true;
            select.Checked = true;
          }
        });
      });
    }

    if (this.currentSelectionData) {
      this.currentSelectionData.forEach((outer) => {
        this.dataSource.data.forEach((inner) => {
          if (outer[this.PrimaryColumn] == inner[this.PrimaryColumn]) {
            let found = false;
            for (let i = 0; i < this.selection.selected.length && !found; i++) {
              if (this.selection.selected[i][this.PrimaryColumn] == inner[this.PrimaryColumn]) {
                found = true;
                this.selection.deselect(this.selection.selected[i]);
              }
            }
            this.selection.select(inner);

            inner.Checked = true;
            outer.Checked = true;
          }
        });
      });
    }
  }

  allToggled() {
    this.unMarkAsTouched();
    if (this.isAllSelected()) {
      this.selection.clear();
      this.allToggledModel = false;
      this.allPageToggledModel = false;
      this.Selected.emit(this.selection.selected);
    } else {
      this.allToggledModel = true;
      this.allPageToggledModel = true;
      this.dataSource.data.forEach((row) => {
        if (this.SelectDisabledFn == null || !this.SelectDisabledFn(row)) {
          this.selection.select(row)
        }
      });
      this.Selected.emit([]);
    }
    this.SelectionData = [];
    this.currentSelectionData = [];
    this.AllSelectedList.emit({ toggled: this.allToggledModel, list: this.selection.selected });
    this.AllSelected.emit(this.allToggledModel);
  }

  pageToggled() {
    this.unMarkAsTouched();
    if (this.isPageSelected()) {
      this.selection.clear();
      this.allPageToggledModel = false;
      this.allToggledModel = false;
      this.Selected.emit(this.selection.selected);
    } else {
      this.allPageToggledModel = true;
      this.allToggledModel = this.isAllSelected();

      this.dataSource.data.forEach((row) => {
        if (this.SelectDisabledFn == null || !this.SelectDisabledFn(row)) {
          this.selection.select(row)
        }
      });
      this.Selected.emit(this.selection.selected);
    }
    this.SelectionData = [];
    this.currentSelectionData = [];
    this.PageSelectedList.emit(this.selection.selected);
    this.PageSelected.emit(this.allPageToggledModel);
  }

  localAllToggled(e: MatCheckboxChange) {
    this.localAllSelected = e.checked;
    let deselected: any[] = [];
    if (e.checked) {
      console.log(this.selection.selected);

      this.Data.forEach((row) => {
        if (this.SelectDisabledFn == null || !this.SelectDisabledFn(row)) {
          this.selection.select(row)
        }
      });
      this.AllSelectedList.emit({ toggled: this.allToggledModel, list: this.selection.selected });
    } else {
      this.Data.forEach((row) => {
        if (this.selection.isSelected(row)) {
          deselected.push(row);
          this.selection.deselect(row);
        }
      });
      this.Deselected.emit(deselected);
    }

    this.AllSelected.emit(e.checked);
  }

  setSelection(data: any[]) {
    this.currentSelectionData = data;
    this.selection.clear();
    this.currentSelectionData.forEach((element) => {
      this.selection.select(element);
    });
    this.Data.forEach((elem) => {
      if (!this.selection.isSelected(elem)) {
        this.localAllSelected = false;
        return;
      }
    });
    this.checkIfChecked();
  }

  reset() {
    if (this.CustomClearFn == null) {
      this.isExactMatch = false;
      this.isExactMatchChange.emit(this.isExactMatch);
      this.extraQueryClear.emit();
      this.searchTerm.setValue(null);
      this.SearchChange.emit(this.searchTerm.value);
      this.DataCount = null
      this.Data = null;
      if (this.selection && this.ClearSelectionOnClear) {
        this.selection.clear();
      }
      this.Offset = 0;
      this.loading = true;
      this.GetData(this.Offset, '');
      if (!this.ClearSelectionOnClear && this.LocalizeSelectAll) {
        let allSelectedLocal = true;
        for (let i = 0; i < this.Data.length; i++) {
          if (!this.selection.isSelected(this.Data[i])) {
            allSelectedLocal = false;
            break;
          }
        };
        this.localAllSelected = allSelectedLocal;
      }
    } else {
      this.isExactMatch = false;
      this.isExactMatchChange.emit(this.isExactMatch);
      this.extraQueryClear.emit();
      this.searchTerm.setValue(null);
      this.SearchChange.emit(this.searchTerm.value);
      if (this.selection && this.ClearSelectionOnClear) {
        this.selection.clear();
      }
      this.Offset = 0;
      this.loading = true;
      setTimeout(() => {
        this.Data = this.CustomClearFn();
        this.unobtrusiveDataUpdate();
        this.loading = false;

        if (!this.ClearSelectionOnClear && this.LocalizeSelectAll) {
          let allSelectedLocal = true;

          for (let i = 0; i < this.Data.length; i++) {

            if (!this.selection.isSelected(this.Data[i])) {
              allSelectedLocal = false;
              break;
            }
          };
          this.localAllSelected = allSelectedLocal;
          console.log(this.localAllSelected);

        }
      });
    }
  }

  isNumber(v: any) {
    return v == Number;
  }

  isDate(v: any) {
    return v == Date;
  }

  isArray(v: any) {
    return v == Array;
  }

  isObject(v: any) {
    return v == Object;
  }

  isBoolean(v: any) {
    return v == Boolean;
  }

  isString(v: any) {
    return v == String;
  }

  isImage(v: any) {
    return v == Image;
  }

  isAllSelected() {
    if (this.dataSource.data != null && this.selection.selected != null) {
      const numSelected = this.selection.selected.length;
      const numRows = this.dataSource.data.length;

      return (numSelected === numRows && (numSelected > 0 || numRows > 0)) || this.allToggledModel;
    } else return false;
  }

  isPageSelected() {
    if (this.dataSource.data != null && this.selection.selected != null) {
      let allOnPageSelected: boolean = true;

      this.dataSource.data.forEach(row => {
        if (this.SelectDisabledFn == null || !this.SelectDisabledFn(row)) {
          if (this.selection.selected.findIndex((elem) => elem[this.PrimaryColumn] === row[this.PrimaryColumn]) === -1) {
            allOnPageSelected = false;
            return;
          }
        }
      });

      return allOnPageSelected;
    } else return false;
  }

  dynamicCountChanged(eve) {
    this.GetData(0, this.searchTerm.value);
  }

  checkRowExpansion(row) {
    if (this.ExpansionConfig.Expandable === true) {
      this.expandedElement = this.expandedElement === row ? null : row;
      this.ElementExpanded.emit(this.expandedElement);
    }
  }

  advancedSearchClosed() {
    if (this.AdvancedSearchConfig != null) {
      this.AdvancedSearchConfig.Open = false;
    }
  }

  OptionChanged(eve) {
    if (eve != null) {
      if (this.checkOptionType == "combobox") {
        this.checkOptionValue = eve;
        this.CheckOptionChanged.emit(eve);
      } else {
        this.CheckOptionChanged.emit(eve.value);
      }
    }
  }

  AdditionalOptionChanged(eve) {
    if (eve != null) {
      if (this.checkOptionType == "combobox") {
        this.additionalCheckOptionValue = eve;
        this.AdditionalCheckOptionChanged.emit(eve);
      } else {
        this.AdditionalCheckOptionChanged.emit(eve.value);
      }
    }
  }

  ReRenderRows() {
    if (this.matTable != null) {
      this.matTable.renderRows();
    }
  }

  innerHTMLClicked(header: TableHeader, elem: any) {
    if (header.Click != null) {
      header.Click(elem);
    }
  }

  isSelectedCheck(row) {
    if (this.SelectDisabledFn != null) {
      return !this.SelectDisabledFn(row);
    } else {
      return this.selection.selected.findIndex((elem) => elem[this.PrimaryColumn] === row[this.PrimaryColumn]) !== -1;
    }
  }

  doesPrimaryColumnAlwaysExist() {
    let found = true;
    this.Data.forEach((element) => {
      if (!element.hasOwnProperty(this.PrimaryColumn)) {
        found = false;
        return;
      }
    });
    return found;
  }
}
